import React, { useEffect, useState } from 'react'
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { BusAndCargoMemoColumn, BusMemoFooterPDFCOl, busMemoPDFColumn, cargoMemoFooterPDFCOl, cargoMemoPDFColumn, cargoMemoPDFFitlerColumn, cargoMemoPDFFitlerColumn1 } from '../common/AcountingConstants'
import BusAndCargoMemoBody from './BusAndCargoMemoBody'
import { Item } from '../../../common/snippets'
import jsPDF from 'jspdf'
import { callAddFontRobotoNormal } from '../../../common/font/Roboto-normal'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import moment from 'moment'
import autoTable from 'jspdf-autotable'
import { focusElemnt, generateDynamicColumnStyles, navigation3 } from '../../../common/helper'
import * as id from '../common/AcountingId'
const BusAndCargoMemoTable = ({ fromDate, selVehicle, selInclGSTComm, selOfflineBooking, selToPayHamali, getBusMemoPrintData, getCargoMemoPrintData, getCargoMemoReportData, reportData, isPdfLoading, setIsPdfLoading, loginData, CargoMemoVoucherUpdate, updateAlertError }) => {
    const theme = useTheme()
    const { tableHeaderColor } = theme
    const [tableData, setTableData] = useState([])
    const [isEdit, setIsEdit] = useState(false)
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    useEffect(() => {
        if (reportData?.length > 0) {
            setTableData(reportData)
        } else {
            setTableData([])
        }
    }, [reportData])
    const getPrintData = (tripID, chartDate, VoucherNo) => {
        setState({ ...state, load: true, generatePDF: true })
        setIsPdfLoading(true)
        const body = {
            intCompanyId: loginData?.intCompanyID,
            strTripIDs: tripID,
            strChartDate: chartDate,
            intBranchCityID: loginData?.intBranchCityID,
        }
        getBusMemoPrintData(body).then((res) => {
            if (res.status === 'Success') {
                const body1 = {
                    CompanyID: loginData?.intCompanyID,
                    VoucherNo: VoucherNo
                }
                getCargoMemoPrintData(body1).then((res1) => {
                    if (res1.status === 'Success') {
                        groupPrintData(res?.Data, res1?.Data)
                    }
                    else {
                        updateAlertError({ show: true, msg: res1?.ErrMessage, nextId: 'goBtn' })
                        setState({ ...state, load: false, generatePDF: false })
                        setIsPdfLoading(false)
                    }
                })
            } else {
                updateAlertError({ show: true, msg: res?.ErrMessage, nextId: 'goBtn' })
                setState({ ...state, load: false, generatePDF: false })
                setIsPdfLoading(false)
            }
        }).catch((err) => {
            setState({ ...state, load: false, generatePDF: false })
            setIsPdfLoading(false)
            console.log("Error:", err)
        })
    }
    const groupPrintData = (data, cargoData) => {
        let selfBookData = []
        let selfBookTotal = {
            SeatCount: 0,
            TotalFare: 0,
            ServiceTax: 0,
            BaseFarewithSTax: 0,
        }
        let onlineBookData = []
        let onlineBookTotal = {
            SeatCount: 0,
            TotalFare: 0,
            ServiceTax: 0,
            BaseFarewithSTax: 0,
        }
        data.Table.forEach((val) => {
            selfBookData.push({ isRowData: true, ...val, FromToCity: `${val.FromCity}-${val.ToCity}` })
            selfBookTotal = {
                SeatCount: Number((selfBookTotal.SeatCount + Number(val.SeatCount)).toFixed(2)),
                TotalFare: Number((selfBookTotal.TotalFare + Number(val.TotalFare)).toFixed(2)),
                ServiceTax: Number((selfBookTotal.ServiceTax + Number(val.ServiceTax)).toFixed(2)),
                BaseFarewithSTax: Number((selfBookTotal.BaseFarewithSTax + Number(val.BaseFarewithSTax)).toFixed(2)),
            }
        })
        data.Table1.forEach((val) => {
            onlineBookData.push({ isRowData: true, ...val, FromToCity: `${val.FromCity}-${val.ToCity}` })
            onlineBookTotal = {
                SeatCount: Number((onlineBookTotal.SeatCount + Number(val.SeatCount)).toFixed(2)),
                TotalFare: Number((onlineBookTotal.TotalFare + Number(val.TotalFare)).toFixed(2)),
                ServiceTax: Number((onlineBookTotal.ServiceTax + Number(val.ServiceTax)).toFixed(2)),
                BaseFarewithSTax: Number((onlineBookTotal.BaseFarewithSTax + Number(val.BaseFarewithSTax)).toFixed(2)),
            }
        })
        let selfData = data?.Table.length > 0 ? [...selfBookData] : [{ isNoData: true, caption: 'No Records', colSpan: busMemoPDFColumn.length }]
        let onlineData = data?.Table1.length > 0 ? [...onlineBookData] : [{ isNoData: true, caption: 'No Records', colSpan: busMemoPDFColumn.length }]
        let cargoPrintData = cargoData?.Table?.map((val) => ({ ...val, BookingDateTime: moment(val?.BookingDateTime).format('DD-MMM-YY'), JourneyDate: moment(val?.JourneyDate).format('DD-MMM-YY'), FromCity: `${val.FromCity}-${val.ToCity}` }))
        let cargoMemoTotalData = [
            { isRowData: true, Summary: "Freight Section (+)", Amount: cargoData?.Table1?.[0]?.Freight || 0 },
            { isRowData: true, Summary: "Commission (-)", Amount: cargoData?.Table1?.[0]?.Commission || 0 },
            { isRowData: true, Summary: "ToPay Amount (-)", Amount: cargoData?.Table1?.[0]?.ToPayAmt || 0 },
            { isRowData: true, Summary: "S.Tax Section A (+)", Amount: cargoData?.Table1?.[0]?.STax || 0 },
            { isTotalRow: true, Summary: "NET AMOUNT - B", Amount: cargoData?.Table1?.[0]?.NetAmt || 0 },
        ]
        let CargoAndBusMemoTotalData = [
            { isRowData: true, Summary: "NET AMOUNT - A", Amount: Number((selfBookTotal?.BaseFarewithSTax + Number(onlineBookTotal?.BaseFarewithSTax)).toFixed(2)) },
            { isRowData: true, Summary: "NET AMOUNT - B", Amount: cargoData?.Table1?.[0]?.NetAmt || 0 },
            { isTotalRow: true, Summary: "NET AMOUNT - C", Amount: Number((selfBookTotal?.BaseFarewithSTax + Number(onlineBookTotal?.BaseFarewithSTax) + Number(cargoData?.Table1?.[0]?.NetAmt)).toFixed(2)) }
        ]
        printReport(
            [
                { isPrintHeading: true, caption: 'Self Booking' }, { isTableData: true, tableData: [...selfData, { isTotalRow: true, caption: 'Total', ...selfBookTotal }] },
                { isPrintHeading: true, caption: 'Online Booking' }, { isTableData: true, tableData: [...onlineData, { isTotalRow: true, caption: 'Total', ...onlineBookTotal }] }
            ],
            [
                { isRowData: true, Summary: "Self Booking", Amount: selfBookTotal?.BaseFarewithSTax || 0 },
                { isRowData: true, Summary: "Online Booking", Amount: onlineBookTotal?.BaseFarewithSTax || 0 },
                { isTotalRow: true, Summary: "NET AMOUNT - A", Amount: Number((selfBookTotal?.BaseFarewithSTax + Number(onlineBookTotal?.BaseFarewithSTax)).toFixed(2)) }
            ],
            cargoPrintData,
            cargoMemoTotalData,
            CargoAndBusMemoTotalData
        )
    }
    const printReport = (BusMemoData, BusMemoTotalData, cargoMemoData, CargoMemoTotalData, CargoAndBusMemoTotalData) => {
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(['addFonts', callAddFontRobotoNormal])
        const doc = new jsPDF({ orientation: 'p', format: [1240, 1754], unit: 'px', compress: true })
        var pageSize = doc.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
        var scaleFactor = pageWidth / 793;
        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(scaleFactor * 14)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 180, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }
        let pageNumber = -1;
        const jspdfHeader = (data) => {
            if (pageNumber !== doc.internal.getNumberOfPages()) {
                pageNumber = doc.internal.getNumberOfPages()
                doc.setTextColor(scaleFactor * 40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 30, 50, 50)
                doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | Bus & Cargo Memo', 30 + 60, 60)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 60, "right")
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            }
        }
        const HeaderData = [{
            DispatchDate: moment(fromDate).format('DD-MMM-YY'),
            Vehicle: selVehicle?.VehicleWithDetail,
            GenerateMemo: "Bus Cargo Memo",
            GeneratedDateAndTime: moment(new Date()).format('HH:mm, DD-MMM-YY'),
            InclGSTonComm: selInclGSTComm?.name,
            OfflineBooking: selOfflineBooking?.name,
            ToPayHamali: selToPayHamali?.name,
        }]
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: cargoMemoPDFFitlerColumn,
            body: HeaderData,
            startY: 120,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: scaleFactor * 14,
                fontStyle: 'normal',
                font: 'Roboto',
                lineWidth: 0.6,
            },
            columnStyles: {
                0: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                1: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                2: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                3: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
            },
            showHead: "firstPage",
        })
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: cargoMemoPDFFitlerColumn1,
            body: HeaderData,
            startY: doc.lastAutoTable.finalY,
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: scaleFactor * 14,
                fontStyle: 'normal',
                font: 'Roboto',
                lineWidth: 0.6,
            },
            columnStyles: {
                0: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                1: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                2: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                3: { fontSize: scaleFactor * 14, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 250, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
            },
            showHead: "firstPage",
        })
        let drawCell = function (data) {
            var rows = data.table.body
            if (data.row.section === 'head') {
                if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                    data.cell.styles.halign = "right";
                } else {
                    data.cell.styles.halign = "left";
                }
            }
            rows.map((val) => {
                if (val.raw.isTotalRow) {
                    let prevColSpan = 0;
                    for (let key in val.raw) {
                        if (key == 'caption') {
                            val.cells[prevColSpan].text = val.raw.caption.toString();
                            val.cells[prevColSpan].colSpan = 4;
                            val.cells[prevColSpan].styles.halign = 'right'
                            prevColSpan += 4;
                        }
                    }
                } else if (val.raw.isNoData) {
                    val.cells[0].text = val.raw.caption.toString();
                    val.cells[0].colSpan = val.raw.colSpan;
                    val.cells[0].styles.halign = 'center'
                }
            })
        }
        BusMemoData.map((obj) => {
            if (obj?.isPrintHeading) {
                autoTable(doc, {
                    margin: { left: 30, right: 30, bottom: 0 },
                    startY: doc.lastAutoTable.finalY + 24,
                    theme: 'grid',
                    head: [],
                    body: [[obj?.caption]],
                    bodyStyles: {
                        fillColor: [191, 225, 255],
                        textColor: [0, 0, 0],
                        minCellHeight: 36,
                        valign: 'middle',
                        cellPadding: 6,
                        fontSize: scaleFactor * 12,
                        lineWidth: 0.6,
                        font: 'Roboto',
                        fontStyle: "normal"
                    },
                    didParseCell: function (data) {
                        if (data.row.index === 0) {
                            data.cell.styles.textColor = '#000000'
                            data.cell.styles.fillColor = '#BFE1FF'
                        }
                    }
                })
            } else if (obj?.isTableData) {
                autoTable(doc, {
                    margin: { top: 120, left: 30, right: 30, bottom: 40 },
                    alternateRowStyles: {
                        fillColor: [255, 255, 255],
                    },
                    columns: busMemoPDFColumn,
                    tableLineWidth: 0.6,
                    startY: doc.lastAutoTable.finalY,
                    body: obj?.tableData,
                    styles: {
                        lineWidth: [0, 0.6, 0, 0.6]
                    },
                    columnStyles: generateDynamicColumnStyles(busMemoPDFColumn, scaleFactor * 12),
                    theme: 'grid',
                    headStyles: {
                        fillColor: [191, 225, 255],
                        textColor: [0, 0, 0],
                        minCellHeight: 36,
                        valign: 'middle',
                        cellPadding: 6,
                        fontSize: scaleFactor * 12,
                        font: 'Roboto',
                        fontStyle: 'normal'
                    },
                    didParseCell: (data) => {
                        drawCell(data)
                    },
                    willDrawCell: (data) => {
                        if (data.row.raw.isTotalRow) {
                            doc.setFillColor(238, 238, 238);
                            doc.setTextColor(0, 0, 0);
                            data.cell.styles.valign = 'middle';
                            doc.setFontSize(scaleFactor * 12).setFont("Roboto", 'normal')
                        }
                    },
                    didDrawPage: function (data) {
                        jspdfHeader(data)
                    },
                })
            }
        })
        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: BusMemoFooterPDFCOl,
            body: BusMemoTotalData,
            tableWidth: 400,
            startY: doc.lastAutoTable.finalY + 24,
            tableLineWidth: 0.6,
            styles: {
                lineWidth: [0, 0.6, 0, 0.6]
            },
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 6,
                fontSize: scaleFactor * 12,
                fontStyle: 'normal',
                font: 'Roboto',
            },
            columnStyles: {
                0: { fontSize: scaleFactor * 12, textColor: [0, 0, 0], cellPadding: 6, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                1: { fontSize: scaleFactor * 12, textColor: [0, 0, 0], cellPadding: 6, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'right' },
            },
            didParseCell: (data) => {
                if (data.row.section === 'head') {
                    if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                        data.cell.styles.halign = "right";
                    } else {
                        data.cell.styles.halign = "left";
                    }
                }
            },
            willDrawCell: (data) => {
                if (data.row.raw.isTotalRow) {
                    doc.setFillColor(238, 238, 238);
                    doc.setTextColor(0, 0, 0);
                    data.cell.styles.valign = 'middle';
                    doc.setFontSize(scaleFactor * 12).setFont("Roboto", 'normal')
                }
            },
            didDrawPage: function (data) {
                jspdfHeader(data)
            },
        })
        autoTable(doc, {
            margin: { left: 30, right: 30, bottom: 0 },
            startY: doc.lastAutoTable.finalY + 24,
            theme: 'grid',
            head: [],
            body: [['Luggage Booking']],
            bodyStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 6,
                fontSize: scaleFactor * 12,
                lineWidth: 0.6,
                font: 'Roboto',
                fontStyle: "normal"
            },
            didParseCell: function (data) {
                if (data.row.index === 0) {
                    data.cell.styles.textColor = '#000000'
                    data.cell.styles.fillColor = '#BFE1FF'
                }
            },
            didDrawPage: function (data) {
                jspdfHeader(data)
            },
        })
        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: cargoMemoPDFColumn,
            tableLineWidth: 0.6,
            startY: doc.lastAutoTable.finalY,
            body: cargoMemoData,
            styles: {
                lineWidth: [0, 0.6, 0, 0.6]
            },
            columnStyles: generateDynamicColumnStyles(cargoMemoPDFColumn, scaleFactor * 12),
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 6,
                fontSize: scaleFactor * 12,
                font: 'Roboto',
                fontStyle: 'normal'
            },
            didParseCell: (data) => {
                drawCell(data)
            },
            willDrawCell: (data) => {
                if (data.row.raw.isTotalRow) {
                    doc.setFillColor(238, 238, 238);
                    doc.setTextColor(0, 0, 0);
                    data.cell.styles.valign = 'middle';
                    doc.setFontSize(scaleFactor * 12).setFont("Roboto", 'normal')
                }
            },
            didDrawPage: function (data) {
                jspdfHeader(data)
            },
        })
        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: cargoMemoFooterPDFCOl,
            body: CargoMemoTotalData,
            tableWidth: 400,
            startY: doc.lastAutoTable.finalY + 24,
            tableLineWidth: 0.6,
            styles: {
                lineWidth: [0, 0.6, 0, 0.6]
            },
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 6,
                fontSize: scaleFactor * 12,
                fontStyle: 'normal',
                font: 'Roboto',
            },
            columnStyles: {
                0: { fontSize: scaleFactor * 12, textColor: [0, 0, 0], cellPadding: 6, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                1: { fontSize: scaleFactor * 12, textColor: [0, 0, 0], cellPadding: 6, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'right' },
            },
            didParseCell: (data) => {
                if (data.row.section === 'head') {
                    if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                        data.cell.styles.halign = "right";
                    } else {
                        data.cell.styles.halign = "left";
                    }
                }
            },
            willDrawCell: (data) => {
                if (data.row.raw.isTotalRow) {
                    doc.setFillColor(238, 238, 238);
                    doc.setTextColor(0, 0, 0);
                    data.cell.styles.valign = 'middle';
                    doc.setFontSize(scaleFactor * 12).setFont("Roboto", 'normal')
                }
            },
            didDrawPage: function (data) {
                jspdfHeader(data)
            },
        })
        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: BusMemoFooterPDFCOl,
            body: CargoAndBusMemoTotalData,
            tableWidth: 400,
            startY: doc.lastAutoTable.finalY + 24,
            tableLineWidth: 0.6,
            styles: {
                lineWidth: [0, 0.6, 0, 0.6]
            },
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 6,
                fontSize: scaleFactor * 12,
                fontStyle: 'normal',
                font: 'Roboto',
            },
            columnStyles: {
                0: { fontSize: scaleFactor * 12, textColor: [0, 0, 0], cellPadding: 6, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
                1: { fontSize: scaleFactor * 12, textColor: [0, 0, 0], cellPadding: 6, minCellHeight: 36, minCellWidth: 200, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'right' },
            },
            didParseCell: (data) => {
                if (data.row.section === 'head') {
                    if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                        data.cell.styles.halign = "right";
                    } else {
                        data.cell.styles.halign = "left";
                    }
                }
            },
            willDrawCell: (data) => {
                if (data.row.raw.isTotalRow) {
                    doc.setFillColor(238, 238, 238);
                    doc.setTextColor(0, 0, 0);
                    data.cell.styles.valign = 'middle';
                    doc.setFontSize(scaleFactor * 12).setFont("Roboto", 'normal')
                }
            },
            didDrawPage: function (data) {
                jspdfHeader(data)
            },
        })
        doc.setFont('Roboto')
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        setTimeout(() => {
            setState({ ...state, generatePDF: false, load: true })
            document.getElementById('output').data = doc.output('datauristring', 'Bus And Cargo Memo.pdf')
            focusElemnt('backBtn')
        }, 2000)
    }
    const backToScreenView = () => {
        setIsPdfLoading(false)
        const data = document.getElementById('output')
        data.innerHTML = ''
    }
    const handleTableData = (value, index, VoucherNo) => {
        const body = {
            VoucherNo: VoucherNo,
            CompanyID: loginData?.intCompanyID,
            OtherChgManualLess: value?.OtherChgManualLess,
            OtherChgManualAdd: value?.OtherChgManualAdd,
            UserID: loginData?.intUserID,
            BranchID: loginData?.intBranchID
        }
        CargoMemoVoucherUpdate(body).then((res) => {
            if (res.status === 'Success') {
                getCargoMemoReportData()
            } else {
                updateAlertError({ show: true, msg: res?.ErrMessage, nextId: `add-${index}` })
            }
        })
    }
    return (
        <>
            {!isPdfLoading ?
                <Box sx={{ ...sx.reportFlex, paddingTop: '16px !important' }}>
                    <TableContainer className='scrollBlue' component={Paper} sx={{
                        maxHeight: '80vh', marginBottom: "5px",
                    }} >
                        <Table stickyHeader size="small" aria-label="a dense table"
                            sx={{
                                '& .MuiTableCell-root': {
                                    padding: '6px 8px !important',
                                },
                            }}
                        >
                            <TableHead style={{ position: `sticky`, top: `0` }}>
                                <TableRow sx={{ verticalAlign: 'top' }}>
                                    {BusAndCargoMemoColumn.map((col, index) => (
                                        <TableCell
                                            key={`THR-${index}`}
                                            style={{
                                                ...col.headerSx,
                                                minHeight: "36px",
                                                backgroundColor: tableHeaderColor?.isHeadingColor,
                                                color: '#444',
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                whiteSpace: 'pre-line',
                                                lineHeight: 1.3
                                            }}
                                        >
                                            {col.headerName}
                                        </TableCell>))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.length > 0 ? tableData.map((val, index) => <BusAndCargoMemoBody getPrintData={getPrintData} isEdit={isEdit} setIsEdit={setIsEdit} tableData={tableData} printReport={printReport} index={index} val={val} handleTableData={handleTableData} />) :
                                    <TableRow>
                                        <TableCell colSpan={BusAndCargoMemoColumn.length} sx={{ height: '36px', textAlign: 'center', fontSize: '12px', color: '#666', fontWeight: 600 }}>No Record</TableCell>
                                    </TableRow>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box> :
                <>
                    <Box sx={{ ...sx.reportFlex, justifyContent: 'end' }} className="itemButtons">
                        <Item sx={sx.itemsx} className="disabled-wrapper">
                            <Button variant="outlined" id={"backBtn"} sx={{ width: '100%' }} className="receiveitembtn"
                                onClick={backToScreenView}
                                onKeyDown={(e) => {
                                    navigation3(e, id.fromDate, 'loadbtn', () => {
                                        backToScreenView()
                                        focusElemnt('loadbtn')
                                    })
                                }}
                            >
                                Back
                            </Button>
                        </Item>
                    </Box>
                    <Box sx={{ ...sx.reportFlex, justifyContent: 'center', height: '70vh' }}>
                        {state.generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                        {state.load ? (
                            <object
                                id="output"
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                title="MTLPL -Cargo System - Bus And Cargo Memo"
                                aria-label="MTLPL -Cargo System - Bus And Cargo Memo"
                            ></object>
                        ) : (
                            ''
                        )}
                    </Box>

                </>
            }
        </>
    )
}

export default BusAndCargoMemoTable
